import { ILod, ILodInf } from "interface";
import { useTranslation } from "react-i18next";
import { useLocation, useParams } from "react-router-dom";

type IProps = {
  lodInf: any;
};

export default function MbFooter({ lodInf }: IProps) {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const { lodNo } = useParams();
  const isHidden = pathname.includes("login") || pathname.includes("join");

  return (
    <>
      <div
        className={
          "footer-mb" +
          " " +
          (!!lodNo ? "" : "mt-11") +
          " " +
          (pathname.includes("book") ? "pb-[120px]" : "pb-8")
        }
      >
        <div>
          <ul className="flex font-font-B">
            <li>{t("txt_ft_bsnNm")}&nbsp;</li>
            <li>&nbsp;&nbsp;{lodInf?.bizNm?.split(" ")[0]}&nbsp;</li>
            <li>{lodInf?.bizNm?.split(" ")[1]}</li>
          </ul>
          <ul>
            <li>
              {t("txt_ft_ceoNm")}&nbsp;{lodInf?.ceoNm}
            </li>
            <li>
              {t("txt_ft_bizNo")}&nbsp;{lodInf?.bizNo}
            </li>
            <li>
              {t("txt_ft_mailOrdrBizNo")}&nbsp;
              {lodInf?.mailOrdrBizNo}
            </li>
          </ul>
          <ul>
            <li>
              {t("txt_ft_addr")}&nbsp;
              {lodInf?.lodAddr}
            </li>
            <li>
              {t("txt_ft_tl")}&nbsp;{lodInf?.telNo}
            </li>
            <li>
              {t("txt_ft_eml")}&nbsp;{lodInf?.lodEml}
            </li>
          </ul>
        </div>
        <div hidden={isHidden} className="text-left mt-[24px]">
          <p className="text-[10px] text-blue-300">{t("dscrp_ft")}</p>
          <p className="text-[10px]">{t("dscrp_ft_cpyrt")}</p>
        </div>
        {/* <div hidden={!isHidden} className="text-center">
          <p className="text-blue-300">MUSEUM</p>
          <sub className="text-[10px] text-gray-400 ">
            Copyright © 2023 by UBCompany Inc. All right reserved.
          </sub>
        </div> */}
      </div>
    </>
  );
}
